import { useTranslation } from 'react-i18next'
import { ActionRequest, User } from '../types'
import { RequesterType } from '../enums/RequesterType'
import { List, ListItem, ListItemText, ListProps } from '@mui/material'
import {
  isCompanyActionRequest,
  isDeviceActionRequest,
  isProjectActionRequest
} from '../utils/actionRequest'

interface ActionRequestInfoListProps extends Omit<ListProps, 'children'> {
  actionRequest: ActionRequest
}

export default function ActionRequestInfoList({
  actionRequest,
  ...props
}: ActionRequestInfoListProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The requester user.
   */
  const requesterUser =
    actionRequest.requesterType === RequesterType.USER && actionRequest.requester !== undefined
      ? (actionRequest.requester as User)
      : undefined

  return (
    <List {...props}>
      {requesterUser?.firstName && requesterUser?.lastName && (
        <ListItem key="requester.name">
          <ListItemText
            primary={`${requesterUser.firstName} ${requesterUser.lastName}`}
            secondary={t('name')}
          />
        </ListItem>
      )}

      {requesterUser?.email && (
        <ListItem key="requester.email">
          <ListItemText primary={requesterUser.email} secondary={t('email')} />
        </ListItem>
      )}

      {isCompanyActionRequest(actionRequest) && actionRequest.requestable && (
        <ListItem key="company.name">
          <ListItemText primary={actionRequest.requestable.name} secondary={t('company')} />
        </ListItem>
      )}

      {isProjectActionRequest(actionRequest) && actionRequest.requestable && (
        <ListItem key="project.name">
          <ListItemText primary={actionRequest.requestable.name} secondary={t('project')} />
        </ListItem>
      )}

      {isDeviceActionRequest(actionRequest) && actionRequest.requestable && (
        <ListItem key="device.name">
          <ListItemText primary={actionRequest.requestable.name} secondary={t('device')} />
        </ListItem>
      )}

      {actionRequest.role && (
        <ListItem key="role">
          <ListItemText primary={actionRequest.role} secondary={t('requestedRole')} />
        </ListItem>
      )}
      {actionRequest.message && (
        <ListItem key="message">
          <ListItemText primary={actionRequest.message} secondary={t('message')} />
        </ListItem>
      )}
    </List>
  )
}
